<template>
	<div class="customer-info-box">
		<div class="fx-title">
			<p>客户信息</p>
		</div>
		<div class="info-box">
			<div class="customer-box"><span class="info-title" style="margin-top: 5px">客户类别：</span>
				<div>
					<el-select
						class="info-select"
						v-model="ccid"
						filterable
						clearable
						disabled
						placeholder="请选择客户类别"
						@change="setCustomer"
						:popper-append-to-body="true">
						<el-option
							v-for="(item, index) in customerList"
							:key="index"
							:label="item.ccname"
							:value="item.ccid">
						</el-option>
					</el-select>
				</div>
			</div>
			<div class="customer-box"><span class="info-title" style="margin-top: 5px">客户账号：</span>
				<div>
					<el-select
						class="info-select"
						:class="isError? 'is-error' : ''"
						v-model="value"
						filterable
						remote
						clearable
						disabled
						placeholder="请输入客户名称/手机号/注册号"
						@change="setValue"
						:remote-method="remoteMethod"
						:loading="loading"
						:popper-append-to-body="true">
						<el-option
							v-for="(item, index) in options"
							:key="index.userid"
							:label="item.name + '(手机号:' + item.tel + ',注册号:' + item.syscode + ')'"
							:value="item.userid">
						</el-option>
					</el-select>
					<div class="el-form-item__error el-form-item__error--inline" v-show="isError">
						必须选择一个客户
					</div>
				</div>
			</div>
			<div class="address-box" v-show="value"><span class="info-title">收货信息：</span>
				<div>
					<el-radio v-model="radio" :label="item.id" @change="changeRadio" v-for="item in radioList" :key="item.id">收货人： {{item.name}}<span style="width: 1em;display: inline-block;"></span>联系电话：{{item.tel}}<span style="width: 1em;display: inline-block;"></span>收货信息：{{item.addrcopy}}</el-radio>
					<el-radio class="is-address" v-model="radio" @change="changeRadio" label="0">填写临时地址</el-radio>
					<el-form :model="ruleForm" :rules="rules" :inline-message='true' ref="ruleForm" label-position='right' label-width="110px" class="box" v-show="radio === '0'">
						<el-form-item label="收货人姓名:" prop='linkman'>
							<el-input  class='input-box' size='mini' v-model="ruleForm.linkman" :maxlength='20' placeholder="长度不超过20个字符"></el-input>
						</el-form-item>
						<el-form-item label="手机号码:" prop='tel'>
							<el-input  class='input-box' size='mini' v-model="ruleForm.tel" placeholder="请填写手机号码"></el-input>
						</el-form-item>
						<el-form-item label="所在地区:" prop="postion" ref="postion">
							<el-select v-model="ruleForm.province" size='mini' class='select-box region' @change='provinceChange($event, "ruleForm")' placeholder="请选择省份">
								<el-option
									v-for="(item,index) in provinceList"
									:key="index"
									:label="item.name"
									:value="JSON.stringify(item)"
									ref="province">
								</el-option>
							</el-select>
							<el-select v-model="ruleForm.city"  size='mini' class='select-box' @change='cityChange($event, "ruleForm")' placeholder="请选择城市">
								<el-option
									v-for="(item,index) in cityList"
									:key="index"
									:label="item.name"
									:value="JSON.stringify(item)">
								</el-option>
							</el-select>
							<el-select v-model="ruleForm.district"  size='mini' class='select-box' @change='districtChange($event, "ruleForm")' placeholder="请选择区域">
								<el-option
									v-for="(item,index) in areaList"
									:key="index"
									:label="item.name"
									:value="item.code">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="街道地址:" prop='address' class="input540">
							<el-input class='long-input' @input="addressInput" size='mini' v-model="ruleForm.address" :maxlength='100' placeholder="请输入街道地址"></el-input>
						</el-form-item>
						<el-form-item label="详细地址:" prop="memo" class="input540" style="height:102px">
							<el-input type="textarea" size='mini' v-model="ruleForm.memo" :rows='5' :maxlength='50' placeholder='请输入详细地址信息，如道路、门牌号、小区、楼栋号、单元等信息' resize="none" style="height:100px"></el-input>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { cityData } from '@/js/location/city.js'
import { areaData } from '@/js/location/areaData.js'
import { provinceData } from '@/js/location/province.js'
let _AMap = null
export default {
	name: 'valetCInfo',
	props: {
		shopId: {
			type: String
		}
		// clearing: {
		// 	type: String,
		// 	default: '0'
		// },
		// clddock: {
		// 	type: Number,
		// 	default: 0
		// }
	},
	data () {
		var postion = (rule, value, callback) => {
			if (this.isTrue === true) {
				return callback(new Error('请选择地区'))
			} else {
				callback()
			}
		}
		var area = (rule, value, callback) => {
			if (this.waringArea === true) {
				return callback(new Error('请选择区域'))
			} else {
				callback()
			}
		}
		var phone = (rule, value, callback) => {
			var reg = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(19[0-9]{1}))+\d{8})$/
			if (!(reg.test(value))) {
				return callback(new Error('请输入正确手机号'))
			} else {
				callback()
			}
		}
		var isNull = (rule, value, callback) => {
			var reg = /^[\s\S]*.*[^\s][\s\S]*$/
			if (!(reg.test(value))) {
				return callback(new Error(''))
			} else {
				callback()
			}
		}
		return {
			userName: '',
			options: [],
			customerList: [],
			ccid: '',
			value: '',
			buyersyscodeid: '',
			syscode: '',
			list: [],
			loading: false,
			isError: false,
			isTrue: true,
			isWaring: false,
			// states: ['123', 'aaa', '1sdgio23', 'aaegwera', 'qsg', 'htnh', '12gerg3', 'sgew', 'gw', 'wsgwr', 'wegwerg', 'dshber'],
			radio: '1',
			radioList: [],
			provinceListTotal: [],
			provinceList: [],
			cityList: [],
			areaList: [],
			locationLng: '',
			locationLat: '',
			ruleForm: {
				imgurl: '',
				id: null,
				orgname: '',
				abbreviation: '',
				province: '',
				city: '',
				district: '',
				districtname: '',
				syscode: '',
				code: '',
				area: '',
				name: '',
				memo: '',
				linkman: '',
				tel: '',
				address: '',
				address1: '',
				region: '',
				groupcode: '',
				groupname: '',
				shopname: '',
				wayname: ''
			},
			rules: {
				orgname: [
					{ required: true, validator: isNull, message: '请输入企业名称', trigger: 'blur' }
				],
				linkman: [
					{ required: true, validator: isNull, message: '请输入收货人姓名', trigger: 'blur' }
				],
				address: [
					{
						required: true,
						validator: (rule, value, callback) => {
							callback()
						},
						trigger: 'change'
					}
				],
				memo: [
					{ required: true, validator: isNull, message: '请输入地址', trigger: 'blur' }
				],
				area: [
					{ required: true, validator: area, trigger: 'blur' }
				],
				postion: [
					{ required: true, validator: postion, trigger: 'blur' }
				],
				email: [
					{ type: 'email', required: true, message: '请输入正确的邮箱', trigger: 'blur' }
				],
				tel: [
					{ required: true, validator: phone, trigger: 'blur' }
				]
			},
			refundFlag: false,
			dataObj: {},
			shopId2: this.shopId,
			customerid: '',
			defaultRadio: ''
		}
	},
	created () {
		this.refundFlag = this.$route.query.refundFlag
		if (this.refundFlag) {
			this.dataObj = JSON.parse(this.$route.query.dataObj)
			this.refundOrderValet(this.dataObj)
		}
	},
	mounted () {
		this.provinceListTotal = provinceData.RECORDS
		this.provinceList = provinceData.RECORDS
		// this.load()
		this.getCustomer()
		this.remoteMethod()
	},
	methods: {
		getMsg () {
			let cusName = ''
			let address = ''
			let linkman = ''
			this.options.forEach(item => {
				if (this.value === item.userid) {
					cusName = item.name
				}
			})
			if (this.radio === '0') {
				linkman = this.ruleForm.linkman
				address = this.ruleForm.address + this.ruleForm.memo
			} else {
				this.radioList.forEach(item => {
					if (item.id === this.radio) {
						linkman = item.name
						address = item.addrcopy
					}
				})
			}
			let msg = '客户：' + cusName + '联系人：' + linkman + '收货地址：' + address
			return msg
		},
		// 切换地址
		changeRadio (e) {
			console.log(e)
			if (e === '0') {
				this.$emit('setAddress', '0', this.ruleForm.district)
			} else {
				this.$emit('setAddress', 'id', e)
			}
		},
		// 选择客户类别
		setCustomer () {
			this.value = ''
			this.$emit('setValue', this.value)
			this.remoteMethod(this.value)
		},
		// 修改客户
		setValue () {
			if (!this.value) {
				this.isError = true
				this.$emit('changeCus', {})
			} else {
				this.isError = false
			}
			console.log(this.value)
			this.$emit('setValue', this.value)
			for (let i = 0; i < this.options.length; i++) {
				if (this.value === this.options[i].userid) {
					this.buyersyscodeid = this.options[i].buyersyscodeid
					this.customerid = this.options[i].id
					this.syscode = this.options[i].syscode
					this.$emit('setSyscodeid', this.buyersyscodeid)
					this.$emit('changeCus', this.options[i])
					break
				}
			}
			this.options.forEach(item => {
				if (this.value === item.userid) {
					this.userName = item.name
				}
			})
			// this.ruleForm = {
			// 	imgurl: '',
			// 	id: null,
			// 	orgname: '',
			// 	abbreviation: '',
			// 	province: '',
			// 	city: '',
			// 	district: '',
			// 	districtname: '',
			// 	syscode: '',
			// 	code: '',
			// 	area: '',
			// 	name: '',
			// 	memo: '',
			// 	linkman: '',
			// 	tel: '',
			// 	address: '',
			// 	address1: '',
			// 	region: '',
			// 	groupcode: '',
			// 	groupname: '',
			// 	shopname: '',
			// 	wayname: ''
			// }
			// if (this.value !== null && this.value !== '') {
			// 	this.getAddress()
			// }
		},
		// 获取地址
		getAddress () {
			return new Promise((resolve, reject) => {
				let data = {
					buyersyscodeid: this.buyersyscodeid,
					userid: this.value
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/replacorder/addr/list`,
					data: data
				}).then(res => {
					if (this.refundFlag) {
						let tableData = this.dataObj.productList
						this.$fxEventBus.$emit('table', tableData)
					}
					if (res.result) {
						if (res.data.length !== 0) {
							let defaultnum = 0
							let defaultindex = 0
							res.data.forEach((e, index) => {
								if (e.addr.indexOf('{"detail"') !== -1) {
									e.addr = e.addr.replace(/[\r\n\t]/g, '').replace(/(?<=([^{:,]))(")(?=([^}:,]))/g, '\\\"')
									e.addrcopy = JSON.parse(e.addr).detail + JSON.parse(e.addr).local
								}
								if (e.defaultflag) {
									defaultnum += 1
									defaultindex = index
								}
							})
							if (defaultnum === 1) {
								this.radio = res.data[0].id
							} else {
								this.radio = res.data[defaultindex].id
							}
							this.$emit('setAddress', 'id', this.radio)
						} else {
							this.radio = '0'
							this.$emit('setAddress', '0', this.ruleForm.district)
						}
						this.radioList = res.data
					}
					resolve()
				}).catch(error => {
					this.$message.error(error.msg)
				})
			})
		},
		load () {
			return new Promise((resolve, reject) => {
				var url = 'https://webapi.amap.com/maps?v=1.4.14&key=4840e0d822c880f0d785c9a2fa5b9d57'
				var script = document.createElement('script')
				script.charset = 'utf-8'
				script.src = url
				script.async = true
				script.defer = true
				script.type = 'text/javascript'
				document.head.appendChild(script)
				script.onload = () => {
					setTimeout(() => {
						_AMap = window.AMap
						_AMap.plugin(['AMap.Autocomplete'], (res) => {
							this.initSearchInput()
						})
						resolve('suc')
					}, 0)
				}
			})
		},
		initSearchInput () {
			this.autoInput = new _AMap.Autocomplete({
				input: 'searchInput',
				city: '全国',
				citylimit: true,
				datatype: 'poi'
			})
			this.autoInput.on('select', (ev) => {
				this.ruleForm.address = ev.poi.name
				this.locationLng = ev.poi.location.lng
				this.locationLat = ev.poi.location.lat
				// console.log(this.locationLng, this.locationLat)
				this.$refs['ruleForm'].validateField('address', (error) => {
					if (!error) {
						return true
					} else {
						return false
					}
				})
			})
		},
		addressInput (value) {
			this.locationLat = ''
		},
		provinceChange (selVal, data) {
			this.changecity = true
			this.areaList = []
			this.ruleForm.district = ''
			this.cityList = []
			this.ruleForm.city = ''
			let a = cityData.RECORDS
			for (let i = 0; i < a.length; i++) {
				if (JSON.parse(this.ruleForm.province).id === a[i].pid) {
					this.cityList.push(a[i])
				}
			}
			this.postionChange(data)
			this.$emit('setAddress', '0', this.ruleForm.district)
		},
		cityChange (selVal, data) {
			this.changearea = true
			let province = this.changecity ? JSON.parse(this.ruleForm.province).name : this.ruleForm.province
			let city = JSON.parse(this.ruleForm.city).id
			// this.autoInput.setCity(city)
			this.areaList = []
			this.ruleForm.district = ''
			for (let i = 0; i < areaData.length; i++) {
				if (province === areaData[i].name) {
					for (let j = 0; j < areaData[i].child.length; j++) {
						if (city === areaData[i].child[j].code) {
							this.areaList = areaData[i].child[j].child
						}
					}
				}
			}
			this.postionChange(data)
			this.$emit('setAddress', '0', this.ruleForm.district)
		},
		districtChange (selVal, data) {
			this.postionChange(data)
			for (let a = 0; a < this.areaList.length; a++) {
				if (this.ruleForm.district === this.areaList[a].code) {
					this.ruleForm.districtname = this.areaList[a].name
					break
				}
			}
			this.$emit('setAddress', '0', this.ruleForm.district)
		},
		postionChange (formName) {
			if (this.ruleForm.province === '' || this.ruleForm.city === '' || this.ruleForm.district === '') {
				this.isTrue = true
			} else {
				this.isTrue = false
			}
			this.$refs[formName].validateField('postion', (error) => {
				if (!error) {
					return true
				} else {
					return false
				}
			})
		},
		// 客户类别
		getCustomer () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customerCategory/list`
			}).then(res => {
				if (res.result) {
					this.customerList = res.data.childNode
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		// 查询客户
		remoteMethod (query) {
			// if (query !== '') {
			this.loading = true
			let data = {
				keyword: query,
				shopid: this.shopId2,
				ccid: this.ccid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/getCustomerInfo4Business`,
				data: data
			}).then(res => {
				if (res.result) {
					if (this.refundFlag) {
						this.setValue()
					}
					this.loading = false
					// this.list = res.data.map(item => {
					// 	return { value: `${item.name}`, label: `${item.name}` }
					// })
					this.options = res.data
					for (let i = 0; i < this.options.length; i++) {
						if (this.value === this.options[i].userid) {
							this.buyersyscodeid = this.options[i].buyersyscodeid
							break
						}
					}
					// this.setValue()
					// .filter(item => {
					// 	return item.label.toLowerCase()
					// 		.indexOf(query.toLowerCase()) > -1
					// })
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
			// setTimeout(() => {
			// 	this.loading = false
			// 	this.options = this.list.filter(item => {
			// 		return item.label.toLowerCase()
			// 			.indexOf(query.toLowerCase()) > -1
			// 	})
			// }, 200)
			// }
			// else {
			// 	this.options = []
			// }
		},
		refundOrderValet (data) {
			this.ccid = data.customerCategoryId
			this.shopId2 = data.shopId
			this.value = data.userId
			this.remoteMethod()
		},
		errorAddress () {
			// 防止地址重复提交
			this.getAddress().then(() => {
				this.radio = this.defaultRadio
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.customer-info-box {
	padding-left: 10px
	box-sizing: border-box
	// overflow: hidden
	font-size: 14px
	margin-top: 10px
	.el-input {
		height: 30px
	}
	.fx-title {
		font-weight: 700
		margin: 20px 0 10px 0
	}
	.info-box {
		text-align: left
		&>div {
			display: flex
			align-items: flex-start
			padding-left: 14px
		}
		.address-box {
			margin-top: 10px
		}
		.info-title {
			margin-right: 10px;
			flex-shrink: 0
		}
	}
}
</style>
<style lang="stylus">
.customer-info-box {
	.customer-box {
		margin-bottom: 20px;
		.el-input, .el-input__inner {
			height: 30px
			width: 350px
		}
		.info-select {
			.el-icon-:before{
				content: "\e6e1";
			}
			.is-focus{
				.el-icon-{
					transform: rotateZ(0)
				}
			}
		}
		.info-select.is-error {
			.el-input__inner {
				border-color: #F56C6C
			}
		}
		.el-form-item__error {
			display: block
		}
	}
	.el-input__icon {
		line-height: 30px
	}
	.el-radio {
		display: block;
		margin-bottom: 7px;
		&:first-of-type {
			margin-top: 4px
		}
	}
	.el-radio__input.is-checked+.el-radio__label {
		color: #606266;
	}
	.el-radio.is-address .el-radio__label {
		color: var(--fx-primary-color)!important;
	}
	.input-box{
        width :200px;
    }
    .input-box-address{
        width :500px;
    }
    .select-box{
        width :200px;
        margin-right :10px;
    }
    .select-box1{
        width :200px;
    }
	.input540{
		.el-input--mini{
			width:500px
		}
	}
    .el-form-item{
        margin-bottom :2px
        height :40px
    }
    .el-form-item >>> .el-form-item__content{
        text-align :left
    }
	.el-input--mini .el-input__inner {
		height: 28px;
		line-height: 28px;
	}
}
</style>
